import { render } from "./TheFallback.vue?vue&type=template&id=fffa89c0"
import script from "./TheFallback.vue?vue&type=script&lang=js"
export * from "./TheFallback.vue?vue&type=script&lang=js"
script.render = render

export default script